import { Stack, Typography } from '@mui/material';

function Error({ message }: { message?: string }) {
  return (
    <Stack
      mt={4}
      alignItems="center"
      justifyContent="center"
      height="100%"
      width="100%">
      <Typography variant="h2" component="p" className="error" color="error">
        {message || 'Something went wrong. Please close and try again.'}
      </Typography>
    </Stack>
  );
}

export default Error;
